import type { Recipe } from '@/types';

/** Recettes de base — prise de masse sèche, ~1m78 / 67 kg cible */
export const RECIPES: Recipe[] = [
  {
    id: 'omelette_avoine',
    name: "Omelette protéinée + flocons d'avoine",
    type: 'petit-déj',
    kcal: 520, p: 38, g: 55, l: 14,
    time: 10,
    ing: ['3 œufs', "60g flocons d'avoine", '200 ml lait demi-écrémé', '1 banane', '1 c.à.c miel', 'Cannelle'],
    steps: [
      "Préparer les flocons d'avoine avec le lait et la cannelle, 3 min au micro-ondes.",
      'Battre les œufs, cuire en omelette à feu moyen dans une poêle antiadhésive.',
      'Servir avec la banane tranchée et un filet de miel sur le porridge.',
    ],
  },
  {
    id: 'skyr_fruits',
    name: 'Bowl skyr, fruits rouges et noix',
    type: 'petit-déj',
    kcal: 420, p: 32, g: 40, l: 14,
    time: 5,
    ing: ['250g skyr nature', '80g fruits rouges', '30g noix mélangées', '1 c.à.s miel', '20g granola sans sucre ajouté'],
    steps: [
      'Verser le skyr dans un bol.',
      'Ajouter fruits rouges, granola, noix.',
      'Filet de miel.',
    ],
  },
  {
    id: 'oeufs_avocat',
    name: 'Toast œufs pochés / avocat / saumon',
    type: 'petit-déj',
    kcal: 480, p: 30, g: 35, l: 22,
    time: 12,
    ing: ['2 tranches pain complet', '2 œufs', '1/2 avocat', '60g saumon fumé', 'Citron', 'Aneth', "Piment d'Espelette"],
    steps: [
      'Pocher les œufs 3 min dans eau frémissante vinaigrée.',
      "Toaster le pain, écraser l'avocat dessus avec sel/citron.",
      'Disposer saumon, œuf poché, herbes, pincée de piment.',
    ],
  },
  {
    id: 'poulet_riz',
    name: 'Poulet grillé, riz basmati, brocolis',
    type: 'déjeuner',
    kcal: 620, p: 50, g: 70, l: 12,
    time: 25,
    ing: ['180g filet de poulet', '90g riz basmati (poids cru)', '200g brocolis', "1 c.à.s huile d'olive", 'Ail', 'Citron', 'Paprika', 'Sel/poivre'],
    steps: [
      'Mariner le poulet 10 min : huile, ail, paprika, citron.',
      'Cuire le riz selon paquet.',
      'Vapeur les brocolis 7 min.',
      'Griller le poulet 4 min par face. Servir avec un filet de citron.',
    ],
  },
  {
    id: 'saumon_quinoa',
    name: 'Pavé de saumon, quinoa, légumes rôtis',
    type: 'déjeuner',
    kcal: 680, p: 42, g: 55, l: 26,
    time: 30,
    ing: ['180g saumon', '80g quinoa (cru)', '1 courgette', '1 poivron', '1 c.à.s huile olive', 'Thym', 'Citron'],
    steps: [
      'Préchauffer four 200°C. Couper les légumes, huile + thym, rôtir 20 min.',
      'Cuire le quinoa 12 min.',
      "Saisir le saumon côté peau 4 min, puis 2 min de l'autre côté.",
    ],
  },
  {
    id: 'bowl_boeuf',
    name: 'Bowl bœuf haché, patate douce, épinards',
    type: 'déjeuner',
    kcal: 700, p: 45, g: 65, l: 24,
    time: 25,
    ing: ['200g bœuf haché 5%', '250g patate douce', '150g épinards frais', '1 oignon', '1 c.à.s huile olive', 'Cumin', 'Paprika fumé'],
    steps: [
      'Patate douce en dés, rôtir 20 min à 200°C avec huile et épices.',
      "Faire revenir l'oignon, ajouter bœuf haché, cuire 6 min.",
      'Ajouter épinards en fin, laisser tomber 2 min.',
      'Assembler dans le bowl.',
    ],
  },
  {
    id: 'pates_thon',
    name: 'Pâtes complètes, thon, tomates cerises',
    type: 'dîner',
    kcal: 580, p: 38, g: 75, l: 12,
    time: 15,
    ing: ['90g pâtes complètes (cru)', '1 boîte thon naturel', '200g tomates cerises', '2 c.à.s huile olive', 'Ail', 'Basilic', 'Parmesan'],
    steps: [
      'Cuire les pâtes al dente.',
      "Poêler les tomates avec ail dans l'huile 5 min.",
      'Ajouter thon, mélanger, finir avec pâtes, basilic et parmesan.',
    ],
  },
  {
    id: 'poulet_legumes',
    name: 'Émincé de poulet sauté, légumes, sauce soja-gingembre',
    type: 'dîner',
    kcal: 540, p: 48, g: 35, l: 18,
    time: 20,
    ing: ['180g émincé poulet', '200g légumes wok (poivrons, brocolis, carottes)', '50g riz basmati (cru)', '2 c.à.s sauce soja', 'Gingembre frais', 'Ail', 'Huile sésame'],
    steps: [
      'Cuire le riz.',
      'Saisir le poulet à feu vif 4 min, réserver.',
      'Sauter les légumes 5 min, ajouter ail/gingembre.',
      "Remettre le poulet, déglacer à la soja, finir à l'huile de sésame.",
    ],
  },
  {
    id: 'omelette_legumes',
    name: 'Omelette baveuse, courgettes, feta',
    type: 'dîner',
    kcal: 450, p: 32, g: 18, l: 28,
    time: 15,
    ing: ['4 œufs', '1 courgette', '60g feta', 'Menthe', 'Huile olive', 'Poivre'],
    steps: [
      'Râper la courgette, poêler 4 min.',
      'Battre les œufs, verser sur courgettes.',
      'Émietter feta, cuire à feu doux 4 min, plier baveuse.',
      'Finir à la menthe.',
    ],
  },
  {
    id: 'shake_post',
    name: 'Shake post-séance banane-avoine-cacahuète',
    type: 'collation',
    kcal: 420, p: 28, g: 50, l: 12,
    time: 5,
    ing: ['1 dose whey (30g)', '1 banane', '40g flocons d\'avoine', '1 c.à.s beurre de cacahuète', '300 ml lait', 'Cannelle'],
    steps: ['Tout au blender. 30 sec. Boire.'],
  },
  {
    id: 'fromage_blanc',
    name: 'Fromage blanc, miel, amandes',
    type: 'collation',
    kcal: 280, p: 25, g: 22, l: 10,
    time: 2,
    ing: ['250g fromage blanc 3%', '1 c.à.s miel', '20g amandes', 'Cannelle'],
    steps: ['Mélanger. Manger lentement.'],
  },
  {
    id: 'wrap_poulet',
    name: 'Wrap poulet, houmous, crudités',
    type: 'déjeuner',
    kcal: 560, p: 40, g: 55, l: 18,
    time: 12,
    ing: ['1 grande tortilla complète', '150g poulet cuit émincé', '2 c.à.s houmous', '1/4 concombre', '1 tomate', 'Salade', 'Citron'],
    steps: [
      'Étaler houmous sur tortilla.',
      'Disposer poulet et crudités.',
      'Rouler serré, couper en 2.',
    ],
  },
];
